'use client';
import React from 'react';
import { PostProps } from './posts.props';
import { Button, Div, Media } from '@pezeshk-book/ui-kit';
import PostItemMobile from '@layouts/posts/post-item/mobile';
import routes from '@routes';
import CarouselPosts from '@layouts/posts/carousel-posts';
import { useParams } from 'next/navigation';
import getParseRoute from '@utils/helpers/parse-route';
import { LocaleTypes } from '@dictionaries-types';

const Posts = ({ items, bottomArrow, desktop, buttonTitle }: PostProps) => {
  const { lang } = useParams<{lang: LocaleTypes}>();
  return (
    <>
      <Media lessThan={'md'}>
        <Div className={'flex-col w-full'}>
          <Div className={'grid grid-cols-1 sm:grid-cols-2 gap-3 justify-evenly items-center self-center flex-wrap'}>
            {items && items.length > 0 && items.map((postItem: any, index: any) => (
              <PostItemMobile
                key={`postItemMobile_${index}`}
                title={postItem?.title}
                image={postItem?.image?.key_0?.url}
                subtitle={postItem?.title}
                hits={postItem?.hits}
                slug={postItem?.slug}
                publishedAt={postItem?.published_at}
              />
            ))}
          </Div>
          <Button href={getParseRoute({ pathname: routes['route.posts.index'], locale: lang })} className={'z-[3] self-center my-9'} variant={'outlined'}>
            {buttonTitle}
          </Button>
        </Div>
      </Media>
      <Media className={'flex-col'} greaterThan={'sm'}>
        <CarouselPosts
          items={items}
          bottomArrow={!desktop && bottomArrow}
          slides={desktop ? 4 : 7}
          tabletSlides={3}
        />
      </Media>
    </>
  );
};

export default Posts;
